module.exports = __webpack_public_path__ + "media/images/new/ad_free_experience_phone@2x-73c10b6b3aa5dc7dae431ac404b4bb50.png";